import React from "react";
import "./skills.css";
import Programming from "../../assets/ui-design.png"; // you can use a coding icon
import WebDev from "../../assets/web-design.png"; // replace with a web icon
import Database from "../../assets/data-science.png"; // replace with a DB icon

const Skills = () => {
  return (
    <section id="skills">
      <span className="skillTitle">My Skills</span>
      <span className="skillDesc">
        Skilled in multiple programming languages, full-stack web development, and database management.
      </span>

      <div className="skillBars">
        <div className="skillBar">
          <img src={Programming} alt="Programming" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Programming</h2>
            <p>C, Java, Python</p>
          </div>
        </div>

        <div className="skillBar">
          <img src={WebDev} alt="Web Development" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Web Development</h2>
            <p>HTML, CSS, JavaScript, PHP, React</p>
          </div>
        </div>

        <div className="skillBar">
          <img src={Database} alt="Database" className="skillBarImg" />
          <div className="skillBarText">
            <h2>Databases</h2>
            <p>MySQL, PhpMyAdmin</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
